/*
 * Copyright (c) 2005, The haXe Project Contributors
 * All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 *   - Redistributions of source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *   - Redistributions in binary form must reproduce the above copyright
 *     notice, this list of conditions and the following disclaimer in the
 *     documentation and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE HAXE PROJECT CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE HAXE PROJECT CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
 * DAMAGE.
 */
/**
 * package: js
 * class: Lib
 * root Object
 * @constructor
 */
js.Lib = function() {};
$hxClasses['js.Lib'] = js.Lib;
/** @private @type {Array} */
js.Lib.__name__ = ["js","Lib"];
/** @type {js.Document} */
js.Lib.document = null;
/** @type {js.Window} */
js.Lib.window = null;

/**
 * debug
 * Inserts a 'debugger' statement that will make a breakpoint if a debugger is available.
 * *
 * --------------------- *
 *
 * $type TFun([],TEnum(Void,[]))
 * public static inline function debug()
 * @public
 * @static
 * @return {void}
 */
js.Lib.debug = function() {
	debugger;
};


/**
 * alert
 * Display an alert message box containing the given message
 * *
 * --------------------- *
 *
 * $type TFun([{ name => v, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * public static function alert( v : Dynamic )
 * @public
 * @static
 * @param {null}  v 
 * @return {void}
 */
js.Lib.alert = function(v) {
	alert(js.Boot.__string_rec(v,""));
};

/**
 * setErrorHandler
 *
 * $type TFun([{ name => f, t => TFun([{ name => , t => TInst(String,[]), opt => false },{ name => , t => TInst(Array,[TInst(String,[])]), opt => false }],TEnum(Bool,[])), opt => false }],TEnum(Void,[]))
 * public static inline function setErrorHandler( f )
 * @public
 * @static
 * @param {TFun([{ name => , t => TInst(String,[]), opt => false },{ name => , t => TInst(Array,[TInst(String,[])]), opt => false }],TEnum(Bool,[]))}  f 
 * @return {void}
 */
js.Lib.setErrorHandler = function(f) {
	js.Lib.onerror = f;
};

/** @type {js.Lib} */
js.Lib.prototype.__class__ = js.Lib;

/**
 * onerror
 *
 * $type TFun([{ name => , t => TInst(String,[]), opt => false },{ name => , t => TInst(Array,[TInst(String,[])]), opt => false }],TEnum(Bool,[]))
 * @private
 * @static
 * @param {string}   
 * @param {Array}   
 * @return {boolean}
 */
js.Lib.onerror = null;

